<div class="main-wrapper">
  <div class="main-content">
    <!-- global markup for header -->
    <header class="header">
      <div class="content">
        <div class="header__block row">
          <div class="header__arrow col image" (click)="Back()">
            <img
              src="../../../assets/images/header/back-arrow.svg"
              alt="arrow"
            />
          </div>
          <div class="header__title col">
            תמונת מצב - {{ _ss.CustomerInformation.CustName }}
          </div>
          <div
            class="header__burger col image"
            (click)="Restart()"
            style="text-decoration: underline"
          >
            <b> איפוס </b>
          </div>
        </div>
      </div>
    </header>

    <h1
      style="width: 99%; margin: auto; margin-top: 150px; text-align: center"
      *ngIf="DownLoadPdf === true"
    >
      מכין קובץ אנא המתן
    </h1>

    <!--  dashboard-tables markup  -->
    <section
      class="dashboard-tables"
      *ngIf="Main === true"
      style="margin-top: 30px"
    >
      <div class="content">
        <!-- markup for logout popup -->
        <div class="popup" *ngIf="showLogoutPopup">
          <div class="overlay"></div>
          <div class="popup__content popup__content_logout">
            <div class="popup__close" (click)="closepopup()"></div>
            <div class="popup__content-image image">
              <img src="../../../assets/images/logout.gif" alt="photo" />
            </div>
            <h2 class="popup__content-title">לחזור לדף ראשי?</h2>

            <div class="popup__content-block popup__content-block_center">
              <button class="popup__content-button" (click)="exitdashbord()">
                כן, חזור
              </button>
              <button
                class="popup__content-button popup__content-button_red"
                (click)="closepopup()"
              >
                לא, ביטול
              </button>
            </div>
          </div>
        </div>

        <!-- end markup for logout popup -->
        <div class="dashboard-tables__row dashboard-tables__row_scroll">
          <table
            class="dashboard-tables__table-big table"
            cellspacing="0"
            style="height: 200px"
          >
            <thead class="table__head">
              <tr>
                <th class="dashboard-tables__table-big-column_name table__head-column" > שם סוכן </th>
                <th class="dashboard-tables__table-big-column_name table__head-column" > קוד סוכן </th>
                <th class="dashboard-tables__table-big-column_name table__head-column" > סטטוס </th>
                <th class="dashboard-tables__table-big-column_name table__head-column" > מנהל </th>
                <th class="dashboard-tables__table-big-column_name table__head-column" > נתק סוכן </th>
                <th class="dashboard-tables__table-big-column_name table__head-column" > הגדר מנהל </th>
                <th class="dashboard-tables__table-big-column_name table__head-column" > בטל מנהל </th>
                <th class="dashboard-tables__table-big-column_name table__head-column" > סיסמה </th>
                <th class="dashboard-tables__table-big-column_name table__head-column" > הפק סיסמה ראשונית </th>
              </tr>
            </thead>
            <tbody id="first-table" class="table__body" style="height: 200px">
              <tr *ngFor="let a of Agents">
                <td class="dashboard-tables__table-big-column_name table__head-column" > {{ a.UserName }} </td>
                <td class="dashboard-tables__table-big-column_name table__head-column" > {{ a.AgentID }} </td>
                <td class="dashboard-tables__table-big-column_name table__head-column" > {{ a.Logged }} </td>
                <td class="dashboard-tables__table-big-column_name table__head-column" > {{ a.Admin }} </td>
                <td class="dashboard-tables__table-big-column_name table__head-column dashboard-tables__table-column_button"
                (click)="AdminAgentLoggout(a.AgentID)" style="color: #38d88b" >
                  <div class="dashboard-tables__table-button" style="color: red" >
                     נתק
                    </div>
                </td>
                <td class="dashboard-tables__table-big-column_name table__head-column" (click)="AdminAgent(a.AgentID)" >
                  <div class="dashboard-tables__table-button" style="color: #38d88b" > הגדר </div>
                </td>
                <td class="dashboard-tables__table-big-column_name table__head-column" (click)="AdminAgentFalse(a.AgentID)" >
                   <div class="dashboard-tables__table-button" style="color: red" > בטל </div>
                  </td>
                <td class="dashboard-tables__table-big-column_name table__head-column" > {{ a.Password }} </td>
                <td class="dashboard-tables__table-big-column_name table__head-column" (click)="generateLoginPassword(a.AgentID)" >
                  <div class="dashboard-tables__table-button" style="color: red" > הפק </div>
                 </td>
              </tr>
            </tbody>
          </table>
          <h2 *ngIf="Loading === true" style="text-align: right">טוען...</h2>
        </div>

        <div class="dashboard-tables__wrapper">
          <table
            style="font-size: 17px; position: sticky; top: 70px; z-index: 999"
          >
            <tr>
              <th style="background-color: white"><b>סה"כ</b></th>
              <th style="background-color: white"><b>סומנו</b></th>
              <th style="background-color: white; width: 80px">
                <b>בחר סטטוס </b>
              </th>
              <th style="background-color: white; width: 80px">
                <b>בחר חודש </b>
              </th>
              <th style="background-color: white; width: 50px">
                <b>בחר סוכן </b>
              </th>
            </tr>

            <tr>
              <td>{{ this.TotalArray | number : "1.0-3" : "en-US" }}</td>
              <td>{{ this.TotalArrayChecked | number : "1.0-3" : "en-US" }}</td>

              <td style="width: 50px">
                <form [formGroup]="form" (change)="StatusChoosen()">
                  <select
                    formControlName="Status"
                    style="width: 50px; height: 35px"
                  >
                    <option value="0">0</option>
                    <option value="1">1</option>
                  </select>
                </form>
              </td>

              <td style="width: 80px">
                <form [formGroup]="form" (change)="ChangeMonth()">
                  <select
                    formControlName="Month"
                    style="width: 80px; height: 35px"
                  >
                    <option value="01">ינואר</option>
                    <option value="02">פברואר</option>
                    <option value="03">מרץ</option>
                    <option value="04">אפריל</option>
                    <option value="05">מאי</option>
                    <option value="06">יוני</option>
                    <option value="07">יולי</option>
                    <option value="08">אוגוסט</option>
                    <option value="09">ספטמבר</option>
                    <option value="10">אוקטובר</option>
                    <option value="11">נובמבר</option>
                    <option value="12">דצמבר</option>
                  </select>
                </form>
              </td>

              <td style="width: 50px">
                <form [formGroup]="form" (change)="ChangeAgent()">
                  <select
                    formControlName="AgentChosen"
                    style="width: 50px; height: 35px"
                  >
                    <option *ngFor="let a of Agents" value="{{ a.AgentID }}">
                      {{ a.AgentID }}
                    </option>
                  </select>
                </form>
              </td>
            </tr>
          </table>

          <div class="dashboard-tables__row dashboard-tables__row_scroll">
            <b>
              <table class="report-table__table" cellspacing="0">
                <thead class="report-table__table-head">
                  <tr>
                    <th class="report-table__table-head-name">תעודה</th>
                    <th class="report-table__table-head-code">שם לקוח</th>
                    <th class="report-table__table-head-quantity">סוכן</th>
                    <th class="report-table__table-head-quantity">סכום</th>

                    <th class="report-table__table-head-quantity">תאריך</th>
                    <th class="report-table__table-head-quantity">שעה</th>
                    <th class="report-table__table-head-quantity">שורות</th>
                    <th class="report-table__table-head-quantity">סוג תעודה</th>
                    <th class="report-table__table-head-quantity">סטטוס</th>
                    <th class="report-table__table-head-quantity">חברה</th>
                    <th class="report-table__table-head-quantity">ERP סטטוס</th>
                    <th class="report-table__table-head-quantity">הורד קובץ</th>
                    <th class="report-table__table-head-quantity">סמן</th>
                    <th class="report-table__table-head-quantity">
                      אשר לביצוע
                    </th>
                  </tr>
                </thead>
                <tbody class="report-table__table-body">
                  <tr *ngFor="let t of Teudot">
                    <td
                      class="report-table__table-body-name"
                      *ngIf="t.TeudaNewNum.length < 1"
                      style="color: red"
                      (click)="seeTeuda(t.TeudaNum)"
                    >
                      {{ t.TeudaNum.toString().slice(7, 13) }}
                    </td>
                    <td
                      class="report-table__table-body-name"
                      *ngIf="t.TeudaNewNum.length > 1"
                      style="color: #38d88b"
                      (click)="seeTeuda(t.TeudaNum)"
                    >
                      {{ t.TeudaNewNum }}
                    </td>
                    <td class="report-table__table-body-name">
                      {{ t.Client_Name }}
                    </td>
                    <td class="report-table__table-body-quantity">
                      {{ t.AgentID }}
                    </td>
                    <td class="report-table__table-body-quantity" dir="ltr">
                      {{ t.TeudaTotalSum | number : "1.0-3" : "en-US" }}
                    </td>
                    <td class="report-table__table-body-quantity">
                      {{ t.TeudaShowDate.toString().slice(0, 2) }}.{{
                        t.TeudaShowDate.toString().slice(3, 5)
                      }}.{{ t.TeudaShowDate.toString().slice(6, 10) }}
                    </td>
                    <td class="report-table__table-body-quantity">
                      {{ t.TeudaShowTime }}
                    </td>
                    <td class="report-table__table-body-quantity">
                      {{ t.TotalLines }}
                    </td>
                    <td class="report-table__table-body-quantity">
                      {{ t.TeudaTypeName }}
                    </td>
                    <td class="report-table__table-body-quantity">
                      {{ t.Status }}
                    </td>
                    <td class="report-table__table-body-quantity">
                      {{ t.Company }}
                    </td>
                    <td class="report-table__table-body-quantity">
                      {{ t.TuedaErpDocNum || t.TeudaNewNum }}
                    </td>
                    <td
                      class="report-table__table-body-name"
                      *ngIf="t.TeudaNewNum.length < 1"
                      style="color: red"
                    >
                      <img
                        src="assets/pdflogo.png"
                        (click)="
                          seeTeudaPdf(t.TeudaNum, t.TeudaNewNum, t.Client_Name)
                        "
                        style="height: 50px; width: 42px"
                      />
                    </td>
                    <td
                      class="report-table__table-body-name"
                      *ngIf="t.TeudaNewNum.length > 1"
                      style="color: #38d88b"
                    >
                      <img
                        src="assets/pdflogo.png"
                        (click)="
                          seeTeudaPdf(t.TeudaNum, t.TeudaNewNum, t.Client_Name)
                        "
                        style="height: 50px; width: 42px"
                      />
                    </td>

                    <td class="report-table__table-body-quantity">
                      <input
                        type="checkbox"
                        style="height: 20px; width: 20px"
                        (change)="OrderChecked(t.TeudaNum, t.TeudaTotalSum)"
                      />
                    </td>

                    <td
                      class="report-table__table-body-quantity"
                      *ngIf="t.Status === 2 && LoaingConfirm === false"
                      (click)="AdminConfirmOrder(t.TeudaNum)"
                    >
                      <div
                        class="dashboard-tables__table-button"
                        style="color: #38d88b"
                      >
                        הגדר
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b>
          </div>
        </div>
      </div>
    </section>

    <div
      *ngIf="Last === true"
      style="margin-top: 100px; margin-right: 20px"
      dir="rtl"
    >
      <h3 style="text-align: center; font-weight: 600">
        הערה ראשית: {{ this.TeudotTableEach[0].TeudaRemark }}
      </h3>
      <h3 style="text-align: center; font-weight: 600">
        לקוח: {{ this.TeudotTableEach[0].Client_Name }}
      </h3>

      <div class="dashboard-tables__row dashboard-tables__row_scroll">
        <table class="report-table__table" cellspacing="0" id="divId">
          <thead class="report-table__table-head">
            <tr>
              <th
                class="report-table__table-head-quantity"
                style="width: 300px"
              >
                שם פריט
              </th>
              <th class="report-table__table-head-quantity">קוד פריט</th>
              <th class="report-table__table-head-quantity">יחידות</th>
              <th class="report-table__table-head-quantity">אריזות</th>
              <th class="report-table__table-head-quantity">בונוס</th>
              <th class="report-table__table-head-quantity">מחיר</th>
              <th class="report-table__table-head-quantity">נטו</th>
              <!-- <th class="report-table__table-head-quantity">הנחה</th> -->
              <th class="report-table__table-head-quantity">סכום</th>
              <th class="report-table__table-head-quantity">הערה</th>
            </tr>
          </thead>
          <tbody class="report-table__table-body">
            <tr
              class="dashboard-tables__table-big-row dashboard-tables__table-big-row_active"
              *ngFor="let t of TeudotTableEach"
            >
              <td
                class="report-table__table-head-quantity"
                style="width: 300px"
              >
                <b>{{ t.ProductName }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.ProductId }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaQuantity }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaPackQuantity }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaBonusQuantity }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaPrice | number : "1.0-3" : "en-US" }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaItemNetPrice | number : "1.0-3" : "en-US" }}</b>
              </td>
              <!-- <td class="report-table__table-head-quantity"><b>{{t.TeudaItemDiscount | number:'1.0':'en-US'}}</b></td> -->
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaTotalRow | number : "1.0-3" : "en-US" }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaItemRemark }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      *ngIf="Each === true"
      style="margin-top: 100px; margin-right: 20px"
      dir="rtl"
    >
      <h3 style="text-align: center; font-weight: 600">
        הערה ראשית: {{ this.TeudotEach[0].TeudaRemark }}
      </h3>
      <h3 style="text-align: center; font-weight: 600">
        לקוח: {{ this.TeudotEach[0].Client_Name }}
      </h3>

      <div class="dashboard-tables__row dashboard-tables__row_scroll">
        <table class="report-table__table" cellspacing="0" id="divId">
          <thead class="report-table__table-head">
            <tr>
              <th
                class="report-table__table-head-quantity"
                style="width: 300px"
              >
                שם פריט
              </th>
              <th class="report-table__table-head-quantity">קוד פריט</th>
              <th class="report-table__table-head-quantity">יחידות</th>
              <th class="report-table__table-head-quantity">אריזות</th>
              <th class="report-table__table-head-quantity">בונוס</th>
              <th class="report-table__table-head-quantity">מחיר</th>
              <th class="report-table__table-head-quantity">נטו</th>
              <!-- <th class="report-table__table-head-quantity">הנחה</th> -->
              <th class="report-table__table-head-quantity">סכום</th>
              <th class="report-table__table-head-quantity">הערה</th>
            </tr>
          </thead>
          <tbody class="report-table__table-body">
            <tr
              class="dashboard-tables__table-big-row dashboard-tables__table-big-row_active"
              *ngFor="let t of TeudotEach"
            >
              <td
                class="report-table__table-head-quantity"
                style="width: 300px"
              >
                <b>{{ t.ProductName }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.ProductId }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaQuantity }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaPackQuantity }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaBonusQuantity }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaPrice | number : "1.0-3" : "en-US" }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaItemNetPrice | number : "1.0-3" : "en-US" }}</b>
              </td>
              <!-- <td class="report-table__table-head-quantity"><b>{{t.TeudaItemDiscount | number:'1.0':'en-US'}}</b></td> -->
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaTotalRow | number : "1.0-3" : "en-US" }}</b>
              </td>
              <td class="report-table__table-head-quantity">
                <b>{{ t.TeudaItemRemark }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="Last === true">
      <div>
        <table dir="rtl">
          <tr>
            <th *ngFor="let t of TeudotTableEach[0] | objectKeys">{{ t }}</th>
          </tr>
          <tr *ngFor="let teuda of TeudotTableEach">
            <td *ngFor="let t of teuda | objectValues">{{ t }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div *ngIf="Each === true">
      <div>
        <table dir="rtl">
          <tr>
            <th *ngFor="let t of TeudotEach[0] | objectKeys">{{ t }}</th>
          </tr>
          <tr *ngFor="let teuda of TeudotEach">
            <td *ngFor="let t of teuda | objectValues">{{ t }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
